import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { Course } from '../course';
import { CourseService } from '../course.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';

@Component({
    selector: 'app-course-details',
    templateUrl: './course-details.component.html',
    styleUrls: ['./course-details.component.scss'],
    standalone: false
})
export class CourseDetailsComponent extends BaseComponent implements OnInit {
  public courseId: string;
  public course: Course = new Course();

  constructor(public sessionService: SessionService,
    private route: ActivatedRoute,
    private courseSerivce: CourseService,
    stringHelpers: StringHelpers) {
    super(sessionService, stringHelpers);
    this.courseId = this.route.snapshot.paramMap.get('id');
   }

  ngOnInit(): void {
    this.getCourseDetails();
  }

  getCourseDetails(){
    this.isLoading = true;
    this.courseSerivce.getCourseById(this.courseId).subscribe(results => {
      this.course = results
      this.isLoading = false;
    });
  }

}
